import modelsFilterSlice from './modelsFilters-slice';

export const { setActiveModelsFilters, resetState, resetActiveModelsFiltersState } = modelsFilterSlice.actions;

export default modelsFilterSlice;
